import React from 'react';

import { Avatar } from '../Avatar';
import { onEnterAction } from '../utils/a11y';

type Props = {
  children: React.ReactNode;
  title: string | JSX.Element;
  image?: string;
  className?: string;
  rightContainerClassName?: string;
  handleClick?(): void;
  imageFallback?: string;
};

export const AvatarCard = (props: Props): JSX.Element => {
  const { handleClick, title, children, image, imageFallback, className, rightContainerClassName } = props;

  return (
    <div
      className={'flex rounded-2xl w-[300px] xl:w-[410px] border-2 border-gray-300 '
        + `hover:border-sapphire-100 active:border-sapphire px-2 py-4${className ? ` ${className}` : ''}}`}
      onClick={handleClick}
      onKeyDown={(e): void => handleClick ? onEnterAction(e, handleClick) : undefined}
      role='button'
      tabIndex={0}
    >
      <div className='flex items-start px-2'>
        <Avatar imageUrl={image} size={50} fallback={imageFallback} />
      </div>
      <div className={`flex flex-col w-[220px] xl:w-[320px] ${rightContainerClassName}`}>
        <div className='flex flex-row'>
          <span className='text-left font-bold overflow-hidden line-clamp-2'>
            {title}
          </span>
        </div>
        {children}
      </div>
    </div>
  );
};
